/** A row's one time (its settle stamp), in the reader's own clock format. */
export function HistoryTime({ ts }: { ts: number }) {
  const at = new Date(ts);
  return (
    <time
      dateTime={at.toISOString()}
      className="font-mono text-3 text-fg-subtle tabular-nums"
    >
      {at.toLocaleTimeString(undefined, { hour: "numeric", minute: "2-digit" })}
    </time>
  );
}

/** The quiet dot between two things in a meta line. */
export function MetaDot() {
  return (
    <span aria-hidden="true" className="text-fg-faint">
      ·
    </span>
  );
}
